import React, { useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Paper, Typography, Grid } from "@material-ui/core";
import { useParams } from "react-router-dom";
import { DEFAULT_TITLE } from "../../constants";
import Player from "./Player";
import School from "./School";
import TableLink from "../TableLink";

const styles = theme => ({
  root: {
    maxWidth: 1200,
    marginTop: theme.spacing(5),
    padding: theme.spacing(2),
    overflowX: "auto",
    margin: "auto"
  }
});

function Year(props) {
  const { classes } = props;
  const { year } = useParams();
  const yearNum = parseInt(year);

  useEffect(() => {
    document.title = `${yearNum}-${yearNum +
      1} Leaderboards - ${DEFAULT_TITLE}`;
  });

  return (
    <Paper className={classes.root}>
      <div>
        <Typography variant="h4" gutterBottom>
          {`${yearNum}-${yearNum + 1} Leaderboards`}
        </Typography>
        <Grid container spacing={3}>
          <Grid item md={4}>
            <Typography variant="h6">Individual Points Leaders</Typography>
            <Player year={yearNum} orderBy={"points"}></Player>
          </Grid>
          <Grid item md={4}>
            <Typography variant="h6">Individual PP20TUH Leaders</Typography>
            <Player year={yearNum} orderBy={"pp20tuh"}></Player>
          </Grid>
          <Grid item md={4}>
            <Typography variant="h6">Individual Powers Leaders</Typography>
            <Player year={yearNum} orderBy={"powers"}></Player>
          </Grid>
        </Grid>
        <Typography
          variant="caption"
          display="block"
          align="right"
          gutterBottom
        >
          View more {yearNum}-{yearNum + 1} individual records{" "}
          <TableLink
            to={`/record/individual-career?years=${yearNum}&tournamentType=College`}
          >
            here
          </TableLink>
        </Typography>
        <Grid container spacing={3}>
          <Grid item md={4}>
            <Typography variant="h6">School Wins Leaders</Typography>
            <School year={yearNum} orderBy={"wins"}></School>
          </Grid>
          <Grid item md={4}>
            <Typography variant="h6">School PP20TUH Leaders</Typography>
            <School year={yearNum} orderBy={"pp20tuh"}></School>
          </Grid>
          <Grid item md={4}>
            <Typography variant="h6">School PPB Leaders</Typography>
            <School year={yearNum} orderBy={"ppb"}></School>
          </Grid>
        </Grid>
        <Typography
          variant="caption"
          display="block"
          align="right"
          gutterBottom
        >
          View more {yearNum}-{yearNum + 1} school records{" "}
          <TableLink
            to={`/record/school?years=${yearNum}&tournamentType=College`}
          >
            here
          </TableLink>
        </Typography>
      </div>
    </Paper>
  );
}

export default withStyles(styles)(Year);
